import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';
import { useTranslation } from '../t';
import C from '../colors';

function AgreementModal({ onClose }) {
  const [text, setText] = useState('');
  const { t } = useTranslation();
  useEffect(() => {
    axios.get('/agreement.md').then(res => setText(res.data));
  }, []);

  if (!text) return null;

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(26,22,20,.4)', display: 'grid', placeItems: 'center', zIndex: 9999 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 560, maxHeight: '80vh', background: C.paper, border: `1px solid ${C.hair}`, borderRadius: 14, overflow: 'auto', padding: '24px 28px', boxShadow: '0 24px 56px -16px rgba(26,22,20,.32)' }}>
        <h3 style={{ margin: '0 0 16px', fontFamily: C.serif, fontSize: 24, fontWeight: 400, color: C.ink }}>{t('User Agreement')}</h3>
        <div style={{ fontSize: 13, color: C.ink2, lineHeight: 1.7 }}><ReactMarkdown>{text}</ReactMarkdown></div>
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <button onClick={onClose} style={{ padding: '8px 20px', borderRadius: 7, border: `1px solid ${C.hair2}`, background: '#fff', fontFamily: C.sans, fontSize: 13, cursor: 'pointer' }}>{t('Close')}</button>
        </div>
      </div>
    </div>
  );
}

export default AgreementModal;
